import { GET_DEMAND_LETTER } from '@/api';
import { complaintService } from '@/api/complaint';
import { DemandTable, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { useNotification } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import * as React from 'react';

export const DemandLetterScreen = () => {
	const { toastSuccess, toastError } = useNotification();
	const router = useRouter();
	const { id } = router.query;

	const { data: demandDocument } = useQuery({
		queryKey: [GET_DEMAND_LETTER, id],
		queryFn: () =>
			complaintService.getComplaintDocuments(id as string, 'MASS_ACTION'),
		enabled: !!id,
	});

	const copyToClipboardButton = async () => {
		const table = document.querySelector('table');
		if (!table) {
			console.log('Error: Table not found!');
			return;
		}

		const range = document.createRange();
		range.selectNode(table);
		window.getSelection()?.removeAllRanges();
		window.getSelection()?.addRange(range);

		try {
			await navigator.clipboard.write([
				new ClipboardItem({
					'text/html': new Blob([table.outerHTML], { type: 'text/html' }),
				}),
			]);
			toastSuccess('Table copied to clipboard!');
		} catch (error) {
			toastError('Error copying table');
			console.error(error);
		} finally {
			window.getSelection()?.removeAllRanges();
		}
	};

	return (
		<div className="max-w-5xl min-w-[200px] lg:min-w-[500px] mx-auto">
			<div className="bg-white border border-grey-2 rounded-[32px] p-10 m-auto lg:min-h-[500px] mb-10">
				{demandDocument && demandDocument.data.length === 0 ? (
					<Typography
						type="body-1"
						className="font-semibold m-auto text-center h-full"
					>
						No data to show
					</Typography>
				) : (
					<>
						<button
							type="button"
							className="mb-8 flex justify-end ml-auto"
							onClick={() => copyToClipboardButton()}
							title="Copy"
						>
							<Icon
								src={Icons.copy}
								width={16}
								height={16}
								className="w-4 h-4"
							/>
						</button>
						<DemandTable tableData={demandDocument?.data[0]} />
					</>
				)}
			</div>
		</div>
	);
};
